import { render, staticRenderFns } from "./cust-action-items.vue?vue&type=template&id=11c6f1b6&scoped=true"
import script from "./cust-action-items.vue?vue&type=script&lang=js"
export * from "./cust-action-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6f1b6",
  null
  
)

export default component.exports